export enum TechnologyEnum {
  _2G = "_2G",
  _3G = "_3G",
  _4G = "4G",
}
